document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('#MobileMenu');
  const openButton = document.querySelector('[data-menu-open]');
  const closeButton = document.querySelector('[data-menu-close]');

  const setMenu = (open) => {
    if (!menu || !openButton) return;
    menu.hidden = !open;
    openButton.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('menu-open', open);
  };

  openButton?.addEventListener('click', () => setMenu(true));
  closeButton?.addEventListener('click', () => setMenu(false));
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));

  const initializeProducts = (root) => root.querySelectorAll('[data-product-section]').forEach((section) => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const mainImage = section.querySelector('[data-main-product-image]');
    const thumbnails = section.querySelectorAll('[data-product-thumbnail]');
    thumbnails.forEach((button) => button.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = button.dataset.imageSrc;
      mainImage.alt = button.dataset.imageAlt || '';
      thumbnails.forEach((item) => item.classList.remove('active'));
      button.classList.add('active');
    }));

    const variantSelect = section.querySelector('[data-variant-select]');
    const quantity = section.querySelector('[name="quantity"]');
    section.querySelectorAll('[data-quantity-step]').forEach((button) => button.addEventListener('click', () => {
      if (button.dataset.quantityStep === '1') quantity.stepUp();
      else quantity.stepDown();
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    if (!variantSelect) return;

    const variants = JSON.parse(section.querySelector('[data-variant-data]').textContent);
    let names = JSON.parse(section.querySelector('[data-option-names]').textContent);
    const packPattern = /^\s*\d+\s*(pcs?|pieces?|packs?|sets?|pairs?)\s*$/i;
    // Some imported products store style / pack size in a single Shopify option.
    if (names.length === 1 && variants.every((variant) => {
      const parts = variant.options[0].split(' / ');
      return parts.length === 2 && packPattern.test(parts[1]);
    })) {
      variants.forEach((variant) => { variant.options = variant.options[0].split(' / '); });
      names = ['Option', 'Pack size'];
    }
    const packIndex = names.findIndex((name, index) => /^(quantity|pack size|pack quantity)$/i.test(name) || variants.every((variant) => packPattern.test(variant.options[index])));
    if (packIndex >= 0) names[packIndex] = 'Pack size';
    let selected = variants.find((variant) => String(variant.id) === variantSelect.value).options.slice();
    const container = section.querySelector('[data-product-options]');
    const prices = section.querySelectorAll('[data-product-price]');
    const submit = section.querySelector('.add-to-cart');
    const status = section.querySelector('[data-variant-status]');
    const match = (values) => variants.find((variant) => variant.options.every((value, index) => value === values[index]));
    const groups = names.map((name, index) => {
      const fieldset = document.createElement('fieldset');
      fieldset.className = 'option-group' + (index === packIndex ? ' pack-group' : '');
      const legend = document.createElement('legend');
      const choices = document.createElement('div');
      choices.className = 'option-choices';
      fieldset.append(legend, choices);
      const inputs = [...new Set(variants.map((variant) => variant.options[index]))].map((value) => {
        const label = document.createElement('label');
        label.className = 'option-choice';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'option-' + section.dataset.sectionId + '-' + index;
        input.value = value;
        const text = document.createElement('span');
        text.textContent = value;
        const detail = document.createElement('small');
        label.append(input, text, detail);
        choices.append(label);
        input.addEventListener('change', () => {
          selected[index] = value;
          update(true);
        });
        return { input, detail };
      });
      container.append(fieldset);
      return { legend, inputs };
    });
    function update(changeUrl) {
      const variant = match(selected);
      groups.forEach((group, index) => {
        group.legend.textContent = names[index] + ' — ' + selected[index];
        group.inputs.forEach(({ input, detail }) => {
          input.checked = input.value === selected[index];
          const values = selected.slice();
          values[index] = input.value;
          const candidate = match(values);
          detail.textContent = !candidate ? 'Unavailable' : !candidate.available ? 'Sold out' : index === packIndex ? candidate.price : '';
        });
      });
      variantSelect.value = variant ? String(variant.id) : '';
      // Never submit a stale variant for an unavailable combination.
      variantSelect.disabled = !variant;
      if (variant?.quantityRule) {
        quantity.min = variant.quantityRule.min;
        quantity.step = variant.quantityRule.increment;
        if (variant.quantityRule.max) quantity.max = variant.quantityRule.max;
        else quantity.removeAttribute('max');
        const min = Number(quantity.min);
        const step = Number(quantity.step);
        quantity.value = Math.max(min, min + Math.ceil((Number(quantity.value) - min) / step) * step);
        if (quantity.max && Number(quantity.value) > Number(quantity.max)) quantity.value = quantity.max;
      }
      prices.forEach((price) => { price.textContent = variant ? variant.price : 'Unavailable'; });
      submit.disabled = !variant?.available;
      submit.textContent = !variant ? 'Unavailable' : variant.available ? submit.dataset.addLabel : submit.dataset.soldOutLabel;
      status.textContent = !variant ? 'This combination is unavailable. Please choose another option.' : !variant.available ? 'This option is sold out.' : '';
      const checkout = section.querySelector('.shopify-payment-button');
      if (checkout) checkout.hidden = !variant?.available;
      if (variant && changeUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
        if (mainImage && variant.image) {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = variant.image;
          mainImage.alt = variant.imageAlt;
          thumbnails.forEach((item) => item.classList.toggle('active', item.dataset.imageSrc === variant.image));
        }
      }
    }
    update(false);
    section.querySelector('[data-variant-fallback]').hidden = true;
    if (packIndex >= 0) section.querySelector('[data-quantity-note]').textContent = 'Number of selected packs to add to your cart.';
    section.querySelector('[data-product-form]').addEventListener('submit', (event) => {
      if (!match(selected)?.available) event.preventDefault();
    });
  });
  initializeProducts(document);
  document.addEventListener('shopify:section:load', (event) => initializeProducts(event.target));
});
